import { useQuery } from '@tanstack/react-query';
import { unwrap } from '@billda/api';
import { api } from '../../../shared/api/billdaApi';

export interface ActivitySiteOption {
  id: number;
  name: string;
}

/**
 * Org sites for the Activity site filter. Uses the canonical /api/v2/sites list
 * (not the files-scoped accessible-sites endpoint, which only returns sites that
 * have files and comes back empty otherwise).
 */
export function useActivitySites() {
  return useQuery({
    queryKey: ['activity', 'site-options'],
    queryFn: async ({ signal }): Promise<ActivitySiteOption[]> => {
      const res = unwrap(
        await api.legacy.GET('/api/v2/sites', {
          params: { query: { offset: 0, take: 100 } },
          signal,
        })
      );
      return res.items.map(s => ({ id: s.id, name: s.name }));
    },
    staleTime: 60000,
  });
}
